<template>
  <div v-if="hasRegistration" class="panel-header panel-header-lg">
    <h6 style="margin-left: 30px; margin-bottom: 20px;" class="text-white"> {{$ml.get('new_guests_per_month')}} </h6>
    <header-chart :height="222"
                  :data="this.newGuestsMonthlyStats.values"
                  :labels="this.newGuestsMonthlyStats.time"
                  :title="title">
    </header-chart>
  </div>
  <div v-else class="panel-header panel-header-sm"></div>
</template>

<script>
  import HeaderChart from './HeaderChart'
  import { mapGetters } from 'vuex'
  import { MLBuilder } from 'vue-multilanguage'

  export default {
    name: 'overview-header',
    components: {
      HeaderChart
    },
    data(){
      return {
        title: 'New Guests ',
      }
    },
    computed: {
      ...mapGetters(['newGuestsMonthlyStats', 'hasRegistration'])
    },
    async mounted () {}
  }
</script>

<style scoped>

</style>
